// extracted by mini-css-extract-plugin
module.exports = {"link":"_2jC29wD4ZZr0Og-cSLazNE","field":"_2Ngr_5JAJfFXS0b9aE9AHl","table":"V5jtnGVBU1Gr3v7nMg3Fx","cell":"_37Taqzyv2iaNSXEkT3UoDJ"};